import { connect } from 'react-redux';

import ImmutableConverter from 'HOCs/ImmutableConverter';
import ReactModal from 'react-modal';

import { modalSelector } from 'reducers/modal/selectors';
import { hideModal } from 'actions/modal';

import { ROOT_ID, MOUNT_NODE } from 'utils/constants';
import Modal from './component';

if (document && MOUNT_NODE) {
  ReactModal.setAppElement(`#${ROOT_ID}`);
}

const mapDispatchToProps = (dispatch) => ({
  hideModal: () => dispatch(hideModal())
});

const mapStateToProps = (state) => ({
  modal: modalSelector(state)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ImmutableConverter(Modal));
